module.exports = __webpack_public_path__ + "img/logo_platingold.1e5fd0a.svg";